/**
 * Legacy-safe derivation of the active process list from the `opt` query param.
 *
 * Contract (must not change to preserve legacy behavior):
 *  - No `opt`            -> ['ID', 'PD']  (default: ID capture + deposit)
 *  - `opt=ID`            -> ['ID']
 *  - `opt=PD`            -> ['PD']        (deposit)
 *  - `opt=ID,KY`         -> ['ID', 'KY']  (order preserved)
 *  - `opt=ky,id`         -> ['KY', 'ID']  (upper-cased)
 *
 * This mirrors the inline logic in App.js so it can be unit-tested in isolation
 * without rendering the legacy component.
 *
 * @param {string|null|undefined} optionQS
 * @returns {string[]}
 */
export const deriveActiveProcess = (optionQS) => {
  if (!optionQS) {
    return ['ID', 'PD'];
  }
  return optionQS
    .toUpperCase()
    .split(',')
    .map((c) => c.trim())
    .filter((c) => c.length > 0);
};

/** KYC is enabled when the process list includes KY or KG. */
export const isKycEnabled = (activeProcess) =>
  Array.isArray(activeProcess) &&
  activeProcess.some((p) => p === 'KY' || p === 'KG');

/** ID capture is part of the flow. */
export const hasIdCapture = (activeProcess) =>
  Array.isArray(activeProcess) && activeProcess.includes('ID');

/** Deposit is part of the flow. */
export const hasDeposit = (activeProcess) =>
  Array.isArray(activeProcess) && activeProcess.includes('PD');

const processCodes = { deriveActiveProcess, isKycEnabled, hasIdCapture, hasDeposit };
export default processCodes;
